import BulkUploadDetailsSchema, { BulkUploadDetailsSchemaContract } from '../schemas/BulkUploadDetailsSchema';
import { postApi, getApi } from '../utils/Api';
import { BulkUploadGetByTypeRequestContract } from '../schemas/BulkUploadGetByTypeRequest';
import { BulkUploadTypes } from 'constants/bulkUpload';
import BulkUploadStagingDetailsSchema, { BulkUploadStagingDetailsSchemaContract } from '../schemas/BulkUploadStagingDetailsSchema';



const bulkUploadsApi = {
    sendFile : (requestData: FormData) => {
        return postApi<BulkUploadDetailsSchemaContract,FormData>({
            url:`/bulk-uploads/upload-file`,
            responseSchema: BulkUploadDetailsSchema,
            requestData
        },'multipart')
    },

    fetchBulkUploadRecord : (bulkUploadId: number) => {
        return getApi<BulkUploadDetailsSchemaContract>({
            url:`/bulk-uploads/${bulkUploadId}`,
            responseSchema: BulkUploadDetailsSchema
        })
    },

    fetchBulkUploadRecordByType : (bulkUploadType: BulkUploadTypes) => {
    return postApi<BulkUploadDetailsSchemaContract, BulkUploadGetByTypeRequestContract>({
        url:`/bulk-uploads/get-by-type`,
        responseSchema: BulkUploadDetailsSchema,
        requestData: {
            type: bulkUploadType,
          },
    })
    },
    
    fetchBulkUploadStagingRecord : (bulkUploadId: number, page:number, rowLimit:number, sheet?:number) => {
        let url =`/bulk-uploads/${bulkUploadId}/execution-preview?page=${page}&page_size=${rowLimit}`
        if(sheet !== undefined && sheet >= 0){
            url = `${url}&sheet_number=${sheet}`
        }
        return getApi<BulkUploadStagingDetailsSchemaContract>({
            url,
            responseSchema: BulkUploadStagingDetailsSchema
        })
    },

    sendExecuteRequest : (bulkUploadId: number) => {
        return postApi<BulkUploadDetailsSchemaContract,{}>({
            url:`/bulk-uploads/${bulkUploadId}/execute`,
            responseSchema: BulkUploadDetailsSchema
        })
    },

    cancelBulkUpload : (bulkUploadId: number) => {
        return postApi<BulkUploadDetailsSchemaContract,{}>({
            url:`/bulk-uploads/${bulkUploadId}/cancel`,
            responseSchema: BulkUploadDetailsSchema
        })
    },

    updateConfig: ({bulkUploadId, filters}: {bulkUploadId: number, filters: {shouldSendWelcomeEmail: boolean}}) => {
        return postApi<{}, { 
            filters: {
                shouldSendWelcomeEmail: boolean;
            }
        }>({
        url: `/bulk-uploads/${bulkUploadId}/update-input-config`,
        requestData: {
          filters,
        },
        responseSchema: {},
        });
    },
};

export default bulkUploadsApi;